var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mount_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 530 185",
    style: {
      enableBackground: "new 0 0 530 185"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mount4{fill:#8FDE5D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mount4",
    d: "M527.8,173.4c4.3,6,0.5,11.4,0.5,11.4c-6.3,0-16.8,0-18.2,0c-17,0-19.7,0-26.9,0c-40.4,0-48.7,0-113.5,0 c0,0-67.4,0-126.6,0c-130.9,0-110,0-164.6,0l-51.6-0.1c-0.4,0-10.9,0.2-11.3,0.2c-4.9-0.1-7.4-0.1-14.6-0.1 c-13.1,0,109.4-151.4,257.9-183.7C321.9-12.6,508.1,145.9,527.8,173.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium4);
export default __webpack_public_path__ + "static/media/podium_4.355dca63db2bd9248c9aee780443cc22.svg";
export { ForwardRef as ReactComponent };